import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./pages/pages.css";
import "./theme.css"; // deep-red theme, loaded after every other stylesheet
import { ApiProvider } from "./api";
import Layout, { RouterLink } from "./Layout";
import Dashboard from "./pages/Dashboard";
import GenericPage from "./pages/GenericPage";
import NotFound from "./pages/NotFound";
import EditClient from "./pages/customers/EditClient";
import AccountForm from "./pages/finance/AccountForm";
import PODetail from "./pages/purchasing/PODetail";
import EodDetails from "./pages/sales/EodDetails";
import Payslip from "./pages/hr/Payslip";
import SignedOut from "./pages/SignedOut";
import Login from "./pages/Login";
import { AuthProvider, useAuth } from "./auth";
import { PAGES } from "./pages/pageConfig";
// explicit extension: an old registry.js left behind by unzipping over a previous version must not be picked up
import { CUSTOM_PAGES } from "./pages/registry.jsx";

// Flask API address. With npm start (page on port 3000): the same computer, port 5000 - so it works on the PC itself
// (localhost) and from other devices on the network (192.168.x.x). A REACT_APP_API_BASE in frontend/.env that
// points somewhere other than localhost still wins (e.g. a separate API server).
// Served without a port (a VPS behind Nginx: https://erp.example.com, /api forwarded to Flask) -> same address.
const ENV_API = process.env.REACT_APP_API_BASE;
const API_BASE = ENV_API && !/\/\/(localhost|127\.0\.0\.1)(:|\/|$)/.test(ENV_API)
  ? ENV_API
  : window.location.port === ""
    ? window.location.origin
    : `${window.location.protocol}//${window.location.hostname}:5000`;

export default function App() {
  return (
    <ApiProvider base={API_BASE}>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </ApiProvider>
  );
}

function AppRoutes() {
  const { user } = useAuth();
  if (user === undefined) return <div className="app" style={{ display: "grid", placeItems: "center", minHeight: "100vh", color: "#5c5650" }}>Loading…</div>;
  if (!user) return <Routes><Route path="*" element={<Login />} /></Routes>;
  // role "admin" unlocks the admin-only menu items and actions (as $_SESSION['user_role'] did in PHP)
  const USER = user;
  return (
        <Routes>
          <Route element={<Layout username={USER.name} role={USER.role} />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard userRole={USER.role} LinkComponent={RouterLink} />} />
            {Object.keys(PAGES).map((slug) => {
              const Custom = CUSTOM_PAGES[slug];
              return (
                <Route
                  key={slug}
                  path={slug}
                  element={Custom ? <Custom user={USER} /> : <GenericPage key={slug} slug={slug} />}
                />
              );
            })}
            <Route path="update_client/:id" element={<EditClient user={USER} />} />
            <Route path="end_of_day_details/:id" element={<EodDetails />} />
            <Route path="account_form/:id" element={<AccountForm />} />
            <Route path="po/:id" element={<PODetail />} />
            <Route path="payslip/:id" element={<Payslip user={USER} />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="signed-out" element={<SignedOut />} />
          <Route path="login" element={<Navigate to={user.home || "/dashboard"} replace />} />
        </Routes>
  );
}

